// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33ITc","type":"styles_type__3ZAHK","choices":"styles_choices__2Wc4L"};